module.exports = __webpack_public_path__ + "static/media/blog.ad5ad919.svg";